import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-box-info',
  standalone: true,
  templateUrl: './box-info.component.html',
  styleUrl: './box-info.component.css'
})
export class BoxInfoComponent {

  @Input() title: string = '';

}
